import axios from 'axios';
import { GetEvidenceParams } from 'store/downloadItems/actions';
import withUrl from '../utils/url/withUrl';

export default {
  getEvidence: (params: GetEvidenceParams) =>
    axios.get(withUrl(`evidences/${params.id}`)),
};
